import type { GasPayload } from '@atlaskit/analytics-gas-types/src';

import { EVENT_SOURCE, SEARCH_DIALOG_EVENT_SOURCE } from '../../constants/analytics';
import { type ProductKeys } from '../../constants/products';
import { type ConnectorSource } from '../../constants/schemas/3p-config';

import type { OAuthSource } from './oauth-events';

export const onBannerDismissed = ({
	isOnSearchDialog,
	oAuthSource,
	componentName,
	product,
	connectorSource,
}: {
	isOnSearchDialog?: boolean;
	componentName: string;
	oAuthSource?: OAuthSource;
	product?: ProductKeys;
	connectorSource?: ConnectorSource;
}): GasPayload => ({
	source: isOnSearchDialog ? SEARCH_DIALOG_EVENT_SOURCE : EVENT_SOURCE,
	eventType: 'ui',
	actionSubject: 'button',
	action: 'clicked',
	actionSubjectId: 'searchBannerDismissed',
	attributes: {
		// The fireAnalytics function in useAnalytics requires attributes to be defined in additionalAttributes
		// The fireAnalytics function in useQuickFindAnalytics does not require attributes to be defined in additionalAttributes
		// We should consolidate analytics signatures between QF and FPS (https://product-fabric.atlassian.net/browse/QS-7746)
		...(isOnSearchDialog
			? {
					componentName,
					oAuthSource,
					product,
					connectorSource,
				}
			: {
					additionalAttributes: {
						componentName,
						oAuthSource,
						product,
						connectorSource,
					},
				}),
	},
});
